import { render, staticRenderFns } from "./TheBuildingSpaceEditForm.vue?vue&type=template&id=736fa037&"
import script from "./TheBuildingSpaceEditForm.vue?vue&type=script&lang=js&"
export * from "./TheBuildingSpaceEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports